// @ts-nocheck
import { SOCKET_CONTEXT_CHANGED, SOCKET_CONTEXT_CLEARED, SOCKET_INSTANCE_CHANGED } from '../types';

export const changeSocketInstance = instance => ({
    type: SOCKET_INSTANCE_CHANGED,
    payload: instance,
});

export const updateSocketContext = context => ({
    type: SOCKET_CONTEXT_CHANGED,
    payload: context,
});

export const clearSocketContext = () => ({
    type: SOCKET_CONTEXT_CLEARED,
});
